import { integrationsStateSelector } from "./integrationsStateSelector";
import { RootState } from "../../store";

export const integrationsDrawerOpenSelector = (state: RootState): boolean => {
  return !!integrationsStateSelector(state).activeIntegration.type;
};
